import { assertEvent, assign } from 'xstate';

import { setFailureAlreadyShown } from '../utils';
import { type OrderingMachineAction } from './ordering-machine.actions.types';
import { orderingMachineLog } from './ordering-machine.logger';

// ─────────────────────────────────────────────────────────────────────────────

const setHasTriggeredOrderSubmission: OrderingMachineAction = assign({
  hasTriggeredOrderSubmission: true,
});

const clearHasTriggeredOrderSubmission: OrderingMachineAction = assign({
  hasTriggeredOrderSubmission: false,
});

const onFetchStatePostOrderDone: OrderingMachineAction = assign({
  orderId({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchStatePostOrder');
    return event.output.order.id;
  },
  cart({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchStatePostOrder');
    return event.output.cart;
  },
});

const setConfirmStripe: OrderingMachineAction = assign({
  confirmStripe({ event }) {
    assertEvent(event, 'SET_CONFIRM_STRIPE');
    return event.params.confirmStripe;
  },
});

const confirmStripe: OrderingMachineAction = ({ context }) => {
  context.confirmStripe();
};

const setStripeFailureAsAlreadyShown: OrderingMachineAction = ({ context }) => {
  void setFailureAlreadyShown(context.paymentMethodOrIntentId);
};

const changePaymentMethod: OrderingMachineAction = assign({
  paymentMethodOrIntentId({ context, event }) {
    if (!('params' in event) || !event.params) {
      return context.paymentMethodOrIntentId;
    }

    if (!('paymentMethodId' in event.params) || !event.params.paymentMethodId) {
      return context.paymentMethodOrIntentId;
    }

    return event.params.paymentMethodId;
  },
});

const updatePaymentMethods: OrderingMachineAction = assign({
  paymentMethods({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchPaymentMethods');
    return event.output.paymentMethods;
  },
});

const incrementPurchaseAttempt: OrderingMachineAction = assign({
  purchaseAttempt({ context }) {
    return context.purchaseAttempt + 1;
  },
});

const startPollingPaymentState: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `startPollingPaymentState` action.');
};

const clearLocalStorageOrderId: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `clearLocalStorageOrderId` action.');
};

const setStripeFailedToLoad: OrderingMachineAction = assign({
  stripeFailedToLoad: true,
});

// ─────────────────────────────────────────────────────────────────────────────

export const OrderingPaymentActions = {
  setHasTriggeredOrderSubmission,
  clearHasTriggeredOrderSubmission,
  onFetchStatePostOrderDone,
  setConfirmStripe,
  confirmStripe,
  setStripeFailureAsAlreadyShown,
  changePaymentMethod,
  updatePaymentMethods,
  incrementPurchaseAttempt,
  startPollingPaymentState,
  clearLocalStorageOrderId,
  setStripeFailedToLoad,
};
